<script lang="ts">
  // "Reports" tab: download a single-sheet .xlsx of new records (one entity
  // type, optional date range) — see internal/api/handlers/reports.go's
  // exportReport for the backend this drives. No list/table of its own,
  // just the export form.
  import { Download } from 'lucide-svelte';
  import { reportsApi, type ReportExportType } from '$lib/api/crm';
  import { session } from '$lib/state/session.svelte';
  import { getErrorMessage } from '$lib/api/client';

  const TYPE_OPTIONS: Array<{ value: ReportExportType; label: string }> = [
    { value: 'companies', label: 'New Company' },
    { value: 'people', label: 'New Person' },
    { value: 'issues', label: 'New Issue' },
    { value: 'deals', label: 'New Deal' },
    { value: 'activities', label: 'New Touch Point' }
  ];

  let type = $state<ReportExportType>('companies');
  let from = $state('');
  let to = $state('');
  let downloading = $state(false);
  let error = $state('');

  const verticalId = $derived(session.selectedVertical === 'all' ? undefined : session.selectedVertical);

  async function download() {
    error = '';
    downloading = true;
    try {
      await reportsApi.export({ type, from: from || undefined, to: to || undefined, vertical_id: verticalId });
    } catch (err) {
      error = getErrorMessage(err);
    } finally {
      downloading = false;
    }
  }
</script>

<div class="tym-page">
  <div class="tym-card max-w-lg p-5">
    <h2 class="tym-section-title">Download Report</h2>
    <p class="tym-section-sub">Export new records of one type, optionally filtered by created date.</p>

    <div class="mt-5 space-y-4">
      <div>
        <label class="label" for="report-type">Category</label>
        <select id="report-type" class="input" bind:value={type}>
          {#each TYPE_OPTIONS as opt (opt.value)}
            <option value={opt.value}>{opt.label}</option>
          {/each}
        </select>
      </div>
      <div class="flex gap-3">
        <div class="flex-1">
          <label class="label" for="report-from">From</label>
          <input id="report-from" type="date" class="input" bind:value={from} />
        </div>
        <div class="flex-1">
          <label class="label" for="report-to">To</label>
          <input id="report-to" type="date" class="input" bind:value={to} />
        </div>
      </div>
      {#if error}
        <p class="tym-error-state">{error}</p>
      {/if}
      <button type="button" class="btn-primary w-full" onclick={download} disabled={downloading}>
        <Download class="h-4 w-4" />
        {downloading ? 'Downloading…' : 'Download'}
      </button>
    </div>
  </div>
</div>
